import http from "@/api/http.js";

export function getMenu() {
  return [
    {
      displayText: "Home",
      icon: "api/menu-icons/home.svg",
      pageName: "DashboardPage",
      roles: []
    },
    // {
    //   displayText: "Orders",
    //   icon: "api/menu-icons/ecommerce.svg",
    //   pageName: "OrdersPage",
    //   roles: []
    // },
    {
      displayText: "Orders Infoauto",
      icon: "api/menu-icons/ecommerce.svg",
      pageName: "OrdersPageInfoauto",
      roles: []
    },
    {
      displayText: "Orders Flagged",
      icon: "api/menu-icons/flag.svg",
      pageName: "OrdersPageFlagged",
      roles: []
    },
    {
      displayText: "Shipments",
      icon: "api/menu-icons/shipments.svg",
      pageName: "ShipmentsPage",
      roles: []
    },
    {
      displayText: "Products",
      icon: "api/menu-icons/product.svg",
      pageName: "ProductsPage",
      roles: ["superAdmin"]
    },
    {
      displayText: "Departamentos",
      icon: "api/menu-icons/warehouse.svg",
      pageName: "DepartmentsPage",
      roles: ["admin", "superAdmin"]
    },
    {
      displayText: "Warehouses",
      icon: "api/menu-icons/warehouse.svg",
      pageName: "WarehousesPage",
      roles: ["admin", "superAdmin"]
    },
    {
      displayText: "Locations",
      icon: "api/menu-icons/warehouse.svg",
      pageName: "WarehouseLocationsPage",
      roles: ["admin", "superAdmin"]
    },
    {
      displayText: "Carriers",
      icon: "api/menu-icons/carriers.svg",
      pageName: "CarriersPage",
      roles: ["admin", "superAdmin"],
      specialPermission: "can_edit_carriers"
    },
    {
      displayText: "Users",
      icon: "api/menu-icons/users.svg",
      pageName: "UsersPage",
      roles: ["superAdmin"],
      specialPermission: "can_edit_users"
    },
    {
      displayText: "Stock Compare",
      icon: "api/menu-icons/warehouse.svg",
      pageName: "StockComparePage",
      roles: ["superAdmin"],
      specialPermission: "can_manage_warehouse"
    },
    {
      displayText: "Infoauto",
      icon: "api/menu-icons/infoauto.svg",
      pageName: "InfoautoPage",
      roles: ["superAdmin"],
      specialPermission: "can_edit_users"
    },
    {
      displayText: "Info",
      icon: "api/menu-icons/infoauto.svg",
      pageName: "InfoPage",
      roles: ["superAdmin"],
      specialPermission: "can_edit_users"
    },
    {
      displayText: "SS - Stores",
      icon: "api/menu-icons/stores.svg",
      pageName: "StoresPage",
      roles: ["admin", "superAdmin"]
    },
    {
      displayText: "PrintNode",
      icon: "api/menu-icons/shipments.svg",
      pageName: "PrintNodePage",
      roles: ["superAdmin"]
    },
    {
      displayText: "Delivery",
      icon: "api/menu-icons/shipments.svg",
      pageName: "DeliveryTripsPage",
      roles: ["admin", "superAdmin"]
    }
  ];
}

export function getAlerts() {
  return http.get("/alerts").then(res => {
    return res.data;
  });
}

export function getMarketplaces() {
  return http.get("/marketplaces").then(res => {
    return res.data;
  });
}

export function getFlagsHistory() {
  return http.get("orders/flags").then(res => {
    return res.data;
  });
}

export function getOrderStatusList() {
  return http.get("orders/status").then(res => {
    return res.data;
  });
}

export function getSellers() {
  return http.get("sellers").then(res => {
    return res.data;
  });
}
